import Vue from "vue";
import Router from "vue-router";
import multiguard from "vue-router-multiguard";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Login from "./views/Login.vue";
import Boiler from "./views/Boiler.vue";
import Charts from "./views/Charts.vue";
import Sun from "./views/Sun.vue";
import DHW from "./views/DHW.vue";
import Notification from "./views/Notification.vue";
import O2 from "./views/O2.vue";
import Cleaning from "./views/Cleaning.vue";
import Regulation from "./views/Regulation.vue";
import Fan from "./views/Fan.vue";
import Igniter from "./views/Igniter.vue";
import Pump from "./views/Pump.vue";
import Hopper from "./views/Hopper.vue";
import ExtFeed from "./views/ExtFeed.vue";
import Consumption from "./views/Consumption.vue";
import Events from "./views/Events.vue";
import Weather from "./views/Weather.vue";
import System from "./views/System.vue";
import Screen from "./views/Screen.vue";
import Advanced from "./views/Advanced.vue";
import Register from "./views/Register.vue";
import UserLocationMap from "./views/UserLocationMap.vue";
import Settings from "./views/Settings.vue";
import CleaningTimetable from "./views/CleaningTimetable.vue";
import DhwTimetable from "./views/DhwTimetable.vue";
import BoilerTimetable from "./views/BoilerTimetable.vue";
import Backup from "./views/Backup.vue";
import Messages from "./views/Messages.vue";
import WeatherTimetable from "./views/WeatherTimetable.vue";
import ExtFeedTimetable from "./views/ExtFeedTimetable.vue";
import PaymentPlans from "./views/PaymentPlans.vue";
import PaymentAdministration from "./views/PaymentAdministration.vue";
import ZoneHeating from "./views/ZoneHeating.vue";
import ExtEnergy from "./views/ExtEnergy.vue";
import CostingTable from "./views/CostingTable.vue";
import { getLoggedInUser, loginUser } from "./common/HelperFunctions";
import PaymentDetail from "./views/PaymentDetail.vue";

Vue.use(Router);

// login Route guard function to check currently loggedIn user
const userAccessLoginGuard = function(to, from, next) {
  if (getLoggedInUser()) {
    var parsedData = JSON.parse(sessionStorage.vuex);
    if (
      parsedData.user.user.token &&
      parsedData.user.user.credentials == "full"
    ) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
};

// Route guard for all pages to check existing user
const authGuard = function(to, from, next) {
  // if (getLoggedInUser()) {
  const sessionStoreUserData = sessionStorage.vuex
    ? JSON.parse(sessionStorage.vuex)
    : "";
  let sessionUser = "";
  if (sessionStoreUserData && sessionStoreUserData.user.user) {
    sessionUser = sessionStoreUserData.user.user;
  }
  let data = window.location.href.split("#");
  if (data[1]) {
    if (
      sessionUser &&
      sessionUser.credentials === "full" &&
      data[1] === sessionUser.name
    ) {
      next();
    } else {
      console.log("userName: ", data[1]);
      loginUser(data[1]).then(val => {
        if (!val) next("/login");
        else {
          next();
        }
      });
    }
  } else {
    if (sessionUser && sessionUser.name) {
      next();
    } else {
      next("/login");
    }
  }
  // } else {
  //   next("/login");
  // }
};

// Defining routes and routeGuards for all pages
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/charts",
      name: "charts",
      component: Charts,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: multiguard([userAccessLoginGuard])
    },
    {
      path: "/boiler",
      name: "boiler",
      component: Boiler,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/sun",
      name: "sun",
      component: Sun,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/dhw",
      name: "dhw",
      component: DHW,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/messages",
      name: "messages",
      component: Messages,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/notification",
      name: "notification",
      component: Notification,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/o2",
      name: "O2",
      component: O2,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/cleaning",
      name: "Cleaning",
      component: Cleaning,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/regulation",
      name: "Regulation",
      component: Regulation,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/fan",
      name: "Fan",
      component: Fan,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/igniter",
      name: "Igniter",
      component: Igniter,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/pump",
      name: "Pump",
      component: Pump,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/hopper",
      name: "Hopper",
      component: Hopper,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/hopper/extfeed",
      name: "ExtFeed",
      component: ExtFeed,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/hopper/extfeed/extfeed-timetable",
      name: "ExtFeedTimetable",
      component: ExtFeedTimetable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/consumption",
      name: "Consumption",
      component: Consumption,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/events",
      name: "Events",
      component: Events,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/weather",
      name: "Weather",
      component: Weather,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system",
      name: "System",
      component: System,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/screen",
      name: "Screen",
      component: Screen,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/advanced",
      name: "Advanced",
      component: Advanced,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/settings/map",
      name: "UserLocationMap",
      component: UserLocationMap,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/settings",
      name: "Settings",
      component: Settings,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/cleaning/cleaning-timetable",
      name: "CleaningTimetable",
      component: CleaningTimetable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/dhw/dhw-timer",
      name: "DhwTimetable",
      component: DhwTimetable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/boiler/boiler-timer",
      name: "BoilerTimetable",
      component: BoilerTimetable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/backup",
      name: "Backup",
      component: Backup,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/weather/weather-timer/:id",
      name: "WeatherTimetable",
      component: WeatherTimetable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/plans",
      name: "PaymentPlans",
      component: PaymentPlans,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/payment-administration",
      name: "PaymentAdministration",
      component: PaymentAdministration,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/heating",
      name: "ZoneHeating",
      component: ZoneHeating,
      // beforeEnter: multiguard([authGuard])
    },
    {
      path: "/ext-energy",
      name: "ExtEnergy",
      component: ExtEnergy,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/ext-energy/costing",
      name: "CostingTable",
      component: CostingTable,
      beforeEnter: multiguard([authGuard])
    },
    {
      path: "/system/settings/payment",
      name: "PaymentDetail",
      component: PaymentDetail,
      beforeEnter: multiguard([authGuard])
    },
  ]
});
